import type { ReactNode } from 'react';
import type { DropdownMenuRadioItemProps } from '@radix-ui/react-dropdown-menu';
import { DropdownMenuItemIndicator, DropdownMenuRadioItem } from '@radix-ui/react-dropdown-menu';
import type { MenuItemButtonProps } from './MenuItemButton';
import { MenuItemButton } from './MenuItemButton';
import { Icon } from '../Icon';

export type RadioMenuItemProps = DropdownMenuRadioItemProps &
  MenuItemButtonProps & {
    /**
     * Optional `Icon` to use as the indicator that the radio item is selected. Must be an instance of [Icon](../?path=/docs/components-icon--docs)
     */
    indicator?: ReactNode;
    /**
     * The value of the item
     */
    value: DropdownMenuRadioItemProps['value'];
    /**
     * @ignore
     */
    href?: never;
    /**
     * @ignore
     */
    isLoading?: never;
    /**
     * @ignore
     */
    ref?: never;
  };

export const RadioMenuItem = ({
  onSelect,
  value,
  indicator = (
    <Icon
      size="sm"
      type="checkmark"
    />
  ),
  ...props
}: RadioMenuItemProps) => {
  const extraProps = onSelect ? { onSelect } : {};

  return (
    <DropdownMenuRadioItem
      {...extraProps}
      asChild={true}
      value={value}
    >
      <MenuItemButton
        {...props}
        rightIcon={<DropdownMenuItemIndicator>{indicator}</DropdownMenuItemIndicator>}
      />
    </DropdownMenuRadioItem>
  );
};

RadioMenuItem.displayName = 'RadioMenuItem';
